export const REPROCESSING_MODAL = 'REPROCESSING_MODAL';
export const VIEW_SOURCE_MODAL = 'VIEW_SOURCE_MODAL';
export const ERROR_MODAL = 'ERROR_MODAL';
export const ADD_SKILL_DETAILS_MODAL = 'ADD_SKILL_DETAILS_MODAL';
export const ADD_SCENE_MEDIA_MODAL = 'ADD_SCENE_MEDIA_MODAL';
export const DOWNLOAD_CSV_MODAL = 'DOWNLOAD_CSV_MODAL';
export const UPLOAD_CSV_MODAL = 'UPLOAD_CSV_MODAL';
export const CSV_RESULTS_MODAL = 'CSV_RESULTS_MODAL';
export const BUILD_BUNDLES_MODAL = 'BUILD_BUNDLES_MODAL';
export const CREATE_ACTIVITY_MODAL = 'CREATE_ACTIVITY_MODAL';
export const CREATE_SKILL_MODAL = 'CREATE_SKILL_MODAL';
export const CREATE_SKILL_GROUP_MODAL = 'CREATE_SKILL_GROUP_MODAL';



// WEBPACK FOOTER //
// ./src/constants/modalTypes.js